function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "chatting",
  transform: "translate(0.1 0.1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M0,19.508V3.559A3.552,3.552,0,0,1,3.538,0H21.629a.92.92,0,0,1,.917.922v11.7a3.553,3.553,0,0,1-3.538,3.559H7.926a2.454,2.454,0,0,0-1.439.464L1.449,20.259a.9.9,0,0,1-.529.173A.92.92,0,0,1,0,19.508Z",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M22.545,3.559A3.552,3.552,0,0,0,19.008,0H16.56a.922.922,0,0,0,0,1.844h2.448a1.712,1.712,0,0,1,1.7,1.716v14.16l-3.59-2.576a4.269,4.269,0,0,0-2.5-.806H3.537a1.712,1.712,0,0,1-1.7-1.716v-.826a.916.916,0,1,0-1.833,0v.826A3.552,3.552,0,0,0,3.537,16.18H14.619a2.454,2.454,0,0,1,1.439.464L21.1,20.26a.917.917,0,0,0,1.449-.751V3.559Z",
  transform: "translate(8.455 7.045)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-2",
  "data-name": "Path",
  d: "M.884,2.114h10.21a.982.982,0,0,0,.884-1.057A.982.982,0,0,0,11.094,0H.884A.982.982,0,0,0,0,1.057.982.982,0,0,0,.884,2.114Z",
  transform: "translate(5.636 4.932)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-3",
  "data-name": "Path",
  d: "M.884,2.114h10.21a.982.982,0,0,0,.884-1.057A.982.982,0,0,0,11.094,0H.884A.982.982,0,0,0,0,1.057.982.982,0,0,0,.884,2.114Z",
  transform: "translate(5.636 9.159)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.2
}));

function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.2,
    height: 27.688,
    viewBox: "0 0 31.2 27.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.0626cd24.svg";
export { ForwardRef as ReactComponent };